import { IconUserCircle, IconSettings, IconBrain } from "@tabler/icons-react";
import { Link } from "react-router-dom";
import classNames from "classnames";
import "./SettingsNavigation.css";
import { FormattedMessage } from "react-intl";
import config from "../config";
import { User } from "../interfaces";
const isDev = config.ENV === "staging" || config.ENV === "local";

const SettingsNavigation: React.FC<ILayoutProps> = (props: ILayoutProps) => {
  const { path } = props;

  const isAdmin = props.user.role === "admin" || props.user.role === "system";
  return (
    <div className="settings-navigation-container">
      <h1>
        <FormattedMessage id="settings.pageTitle" />
      </h1>
      <div className="settings-navigation">
        <div className="section-title">
          <IconSettings size={17} style={{ marginTop: "2px" }} />
          <div>
            <FormattedMessage id="settings.settingsTitle" />
          </div>
        </div>
        <ul>
          <li
            className={classNames("", {
              selected: path === "/settings" || path === "/settings/language",
            })}
          >
            <Link className="link" to="/settings/language">
              <FormattedMessage id="settings.language" />
            </Link>
          </li>

          {isAdmin && (
            <>
              <li
                className={classNames("", {
                  selected: path === "/settings/team",
                })}
              >
                <Link className="link" to="/settings/team">
                  <FormattedMessage id="settings.teams" />
                </Link>{" "}
              </li>
              <li
                className={classNames("", {
                  selected: path === "/settings/payment",
                })}
              >
                <Link className="link" to="/settings/payment">
                  <FormattedMessage id="settings.payment" />
                </Link>{" "}
              </li>
              <li
                className={classNames("", {
                  selected: path === "/settings/usage",
                })}
              >
                <Link className="link" to="/settings/usage">
                  <FormattedMessage id="settings.usage" />
                </Link>{" "}
              </li>

              <li
                className={classNames("", {
                  selected: path === "/settings/api",
                })}
              >
                <Link className="link" to="/settings/api">
                  <FormattedMessage id="settings.api" />
                </Link>{" "}
              </li>
            </>
          )}
        </ul>
      </div>
      {isAdmin && (
        <div className="settings-navigation">
          <div className="section-title">
            <IconUserCircle size={17} />
            <div>
              <FormattedMessage id="settings.accountTitle" />
            </div>
          </div>
          <ul>
            <li
              className={classNames("", {
                selected: path === "/settings/profile",
              })}
            >
              <Link className="link" to="/settings/profile">
                <FormattedMessage id="settings.company" />
              </Link>
            </li>
          </ul>
        </div>
      )}
      <hr />
      <span className="fs-3 color-step-500">v{config.VERSION.vIdentifier}</span>
    </div>
  );
};

interface ILayoutProps {
  path: string;
  user: User;
}

export default SettingsNavigation;
